module.exports = __webpack_public_path__ + "img/DieDrachen.cfb5f49b.svg";